import { IncidentDetailsMutationBodyParams } from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/body/incidentDetailsMutationBody.types';
import { fetchApi } from '@/config/axiosSetting.ts';

const incidentDetailsMutationBody = ({
  id,
  formData,
}: IncidentDetailsMutationBodyParams) => {
  return fetchApi({
    method: 'PATCH',
    url: `/body/reports/${id}/accident_information/`,
    data: formData,
  });
};

export default incidentDetailsMutationBody;
